import { render, staticRenderFns } from "./DistributorGroup.vue?vue&type=template&id=3481776a&"
import script from "./DistributorGroup.vue?vue&type=script&lang=js&"
export * from "./DistributorGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports